import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-folio',
  templateUrl: './folio.component.html',
  styleUrls: ['./folio.component.scss']
})
export class FolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
